import React from 'react';
import { Box } from '../Box/Box';
import { Flex } from '../Flex/Flex';
import { Relative } from '../Relative/Relative';
export function SlideBoxWrapper({
  children,
  arrowPosition
}) {
  return arrowPosition === 'side' ? React.createElement(Relative, null, React.createElement(Flex, {
    alignItems: 'center'
  }, children)) : React.createElement(Box, null, children);
}